import { Layers } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
              <Layers className="text-white w-4 h-4" />
            </div>
            <div>
              <p className="font-bold text-gray-900 leading-tight">
                APIC <span className="text-indigo-600">ProtoHub</span>
              </p>
              <p className="text-[10px] tracking-wide text-gray-500">ANDHRA PRADESH</p>
            </div>
          </div>
          <p className="text-sm text-gray-500 max-w-xs">
            The unified digital operating system for Andhra Pradesh's
            Advanced Prototyping & Innovation Centres.
          </p>
        </div>

        <div>
          <h4 className="font-semibold text-gray-900 mb-4">Platform</h4>
          <ul className="space-y-2 text-sm text-gray-600">
            <li><a href="#facilities" className="hover:text-indigo-600">Facilities</a></li>
            <li><a href="#machines" className="hover:text-indigo-600">Machines</a></li>

            <li><a href="#dashboard" className="hover:text-indigo-600">Innovator</a></li>
            <li><a href="#admin" className="hover:text-indigo-600"></a>Export</li>

          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-gray-900 mb-4">Get started</h4>
          <ul className="space-y-2 text-sm text-gray-600">
            <li><a href="#register" className="hover:text-indigo-600">Register</a></li>
            <li><a href="#login" className="hover:text-indigo-600">Login</a></li>
            <li><a href="#how-it-works" className="hover:text-indigo-600">How it works</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gray-100 py-6">
        <div className="max-w-7xl mx-auto px-6 flex flex-wrap items-center justify-between gap-3 text-xs text-gray-500">
          <p>© 2026 APIC ProtoHub · Government of Andhra Pradesh</p>
          <p>Discover · Design · Prototype · Innovate</p>
        </div>
      </div>
    </footer>
  );
}